import { render, staticRenderFns } from "./Layout_Leaderboard_Entry.vue?vue&type=template&id=2f2152b6&"
import script from "./Layout_Leaderboard_Entry.vue?vue&type=script&lang=js&"
export * from "./Layout_Leaderboard_Entry.vue?vue&type=script&lang=js&"
import style0 from "./Layout_Leaderboard_Entry.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports